export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14402.8afa22cf.jpg";